export const metricPrefixes = [
    [10 ** -15, 'f'],
    [10 ** -12, 'p'],
    [10 ** -9, 'n'],
    [10 ** -6, 'μ'],
    [10 ** -3, 'm'],
    [10 ** -2, 'c'],
    [10 ** -1, 'd'],
    [10 ** 0, ''],
    [10 ** 3, 'k'],
    [10 ** 6, 'M'],
    [10 ** 9, 'G'],
    [10 ** 12, 'T'],
    [10 ** 15, 'P'],
    [10 ** 18, 'E']
] as const;
